export default __webpack_public_path__ + "b37b2f668634828caf1ff1153d337df7.svg";